import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { values } from 'lodash';
import { CrashMailInputParameters } from '../models/CrashMailInputParameters';
import { UserContactUs } from '../models/Auth';
import { TblBidDataDisplay } from '../models/TblBidDataDisplay';
import { LoadingSpinnerService } from './loading-spinner.service';
import { WbidHelper } from '../utilities/helper';
import { WbidCoreService } from './wbid-core.service';
import { GlobalStoreOperation } from '../utilities/store-operations';

@Injectable({
  providedIn: 'root',
})
export class CrashMailService {
  crashInput: CrashMailInputParameters;
  userData: UserContactUs;
  BidDataDisplay: TblBidDataDisplay;
  constructor(
    public loader: LoadingSpinnerService,
    public helper: WbidHelper,
    public wbidCore: WbidCoreService,
    public store: GlobalStoreOperation
  ) {}

  public sendCrashMail = (errorContent): void => {
    if (document.cookie) {
      this.userData = JSON.parse(document.cookie);
      this.setErrorObject(errorContent);
      this.sendMail();
    } else {
      this.downloadAndSetUserData(errorContent);
    }
  };

  public downloadAndSetUserData = (errorContent) => {
    this.userData = new UserContactUs();
    this.userData.AppVersion = environment.version;
    document.cookie = JSON.stringify(this.userData);
    const empId = this.helper.getUserId(true);
    if (empId) {
      const formattedEmployeeNo = empId;
      this.wbidCore.GetUserById(formattedEmployeeNo).subscribe((res) => {
        if (res != null) {
          this.userData.FirstName = res.FirstName;
          this.userData.Email = res.Email;
          this.userData.AppVersion = environment.version;
          this.userData.EmployeeNumber = res.EmpNum.toString();
          this.userData.LastName = res.LastName;
          document.cookie = JSON.stringify(this.userData);
          this.setErrorObject(errorContent);
          this.sendMail();
        }
      });
    }
  };

  public setErrorObject = (errorContent) => {
    const BidDataDisplay: TblBidDataDisplay = this.store.getCurrentBidData();
    this.crashInput = new CrashMailInputParameters();
    this.crashInput.BidData = BidDataDisplay ? BidDataDisplay : null;
    this.crashInput.BidData.EmpNum = this.helper.getUserId(true);
    this.crashInput.OS = this.helper.detectPlatForm();
    this.crashInput.UserData = this.userData;
    this.crashInput.ErrorContent = errorContent;
    this.crashInput.DateTime = new Date();
    this.crashInput.OnlineStatus = true;
  };

  public sendMail = (): void => {
    this.wbidCore.SendCrashMail(this.crashInput).subscribe(
      (response) => {
        if (response.Message.toLowerCase() == 'success') {
          this.showErrorAlert();
        }
      },
      (error) => {
        const CrewbidPendingCrashDataStr =
          localStorage.getItem('PendingCrashData');
        let pendingCrashDataArr = [];
        if (CrewbidPendingCrashDataStr) {
          pendingCrashDataArr = values(JSON.parse(CrewbidPendingCrashDataStr));
        }
        pendingCrashDataArr.push(this.crashInput);
        localStorage.setItem(
          'PendingCrashData',
          JSON.stringify(pendingCrashDataArr)
        );
        this.showErrorAlert();
      }
    );
  };

  public checkForPendingCrash() {
    const pendingCrashDataStr = localStorage.getItem('PendingCrashData');
    let pendingCrashDataArr: CrashMailInputParameters[] = [];
    const deviceDetails = this.helper.detectPlatForm();
    const platFormDetails = `${deviceDetails.OSName} -- ${deviceDetails.BrowserName} -- ${deviceDetails.Version}`;
    if (pendingCrashDataStr) {
      pendingCrashDataArr = JSON.parse(pendingCrashDataStr);
      pendingCrashDataArr.filter(
        (x) => (x.UserData.Platform = platFormDetails)
      );
      pendingCrashDataArr.forEach((x) => (x.OnlineStatus = false));
      for (let i = 0; i < pendingCrashDataArr.length; i++) {
        this.wbidCore.SendCrashMail(pendingCrashDataArr[i]).subscribe(
          (response) => {
            if (response.Message.toLowerCase() == 'success') {
              localStorage.removeItem('PendingCrashData');
            }
          },
          (error) => {
            this.sendCrashMail(
              `Function Name:checkForPendingCrash  ${error.stack.toString()}`
            );
          }
        );
      }
    }
  }

  public showErrorAlert() {
    this.loader.hideSpinner();
    Swal.fire({
      title: 'WbidMax',
      text: 'Error : Please Contact Administrator',
      icon: 'error',
    });
  }
}
